<template>
  <component
    v-bind:is="isCombobox ? 'v-combobox' : 'v-autocomplete'"
    v-bind="$attrs"
    v-on="$listeners"
    :value="value"
    @input="v => $emit('input', v)"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    :chips="chips"
    :multiple="multiple"
    :disabled="disabled"
    :label="label"
    :hide-details="hideDetails"
    :dense="dense"
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title> Start typing to search (more than 3 characters)</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-if="chips && multiple" v-slot:selection="{ attrs, item, index, selected }">
      <v-chip v-bind="attrs" :input-value="selected" :close="true" @click:close="removeChip(index)">
        <span class="pr-2">
          {{ item.name }}
        </span>
      </v-chip>
    </template>
    <template v-slot:append>
      <slot name="append" />
    </template>
  </component>
</template>

<script>
import VInput from 'vuetify/lib/components/VInput/VInput.js';
import { VCombobox } from 'vuetify/lib';
import { VAutocomplete } from 'vuetify/lib';

export default {
  name: 'InputAutocompleteSearch',
  extends: VInput,
  components: { VCombobox, VAutocomplete },
  inheritAttrs: false,
  props: {
    value: [Array, String, Object],
    isCombobox: {
      type: Boolean,
      default: false,
    },
    chips: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'A label',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: null,
      required: true,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLoading: false,
    search: null,
    items: [],
  }),
  created() {
    Array.prototype.push.apply(this.items, this.value);
  },
  watch: {
    search(val) {
      if (val == null) return;

      if (val.trim().length < 3) return;
      // Items have already been requested
      if (this.isLoading) return;

      this.isLoading = true;

      // Lazily load input items
      this.axios
        .get(this.url + val)
        .then(res => {
          this.items = res.data.content;
          if (!this.isCombobox) {
            Array.prototype.push.apply(this.items, this.value);
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    value() {
      if (!this.isCombobox) {
        Array.prototype.push.apply(this.items, this.value);
      }
    },
  },
  methods: {
    removeChip(index) {
      let array = this.value;
      array.splice(index, 1);
      this.$emit('input', array);
    },
  },
};
</script>
